import { Injectable } from '@angular/core';
import { ZoomType } from '../../../../modules/flow/services/flowBuilder/zoom.service';

enum User_Store {
  ZOOM_PREF = 'zoomPreference',
  MESG_DISPLAY = 'messageDisplay',
}

@Injectable({
  providedIn: 'root',
})
export class UserStoreService {
  private userStore: Storage;

  constructor() {
    this.userStore = window.localStorage;
  }

  private set(key: string, value: any) {
    this.userStore.setItem(key, value);
  }

  private get(key: string): any {
    return this.userStore.getItem(key);
  }

  set setZoomPreference(zoomType: ZoomType) {
    this.set(User_Store.ZOOM_PREF, zoomType);
  }

  get getZoomPreference(): ZoomType {
    const zoomPref = this.get(User_Store.ZOOM_PREF);
    return zoomPref ? zoomPref : 'scrollZoom';
  }

  set setMessageDisplay(display: Boolean) {
    this.set(User_Store.MESG_DISPLAY, display);
  }

  get getMessageDisplay(): Boolean {
    return this.get(User_Store.MESG_DISPLAY);
  }
}
